import React from 'react';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import AddressBookUtil from '../utils/AddressBookUtil'
import { numHyphen, removalBlank, zenHan, validateNgExcel } from '../../../utils/validator'
import DialogModal from '../../common/DialogModal';
import Upload from '../../Icons/Upload'

const styles = () => ({
  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '35px 0px 55px 0px'
  },

  uploadBtn: {
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    fontSize: '15px',
    fontWeight: 400,
    padding: '14px 26px',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    },
  },

  disabledUploadBtn: {
    pointerEvents: 'none',
    background: '#F4F6F9',
    color: '#B1B3B9',
    border: '1px solid #D8DBDF',
  },

  hidden: {
    display: 'none',
  },

  importContainer: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
  },

  row: {
    padding: '20px 10px 20px 20px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    borderBottom: '1px solid #D8DBDF',
    boxSizing: 'border-box',
  },

  title: {
    textAlign: 'left',
    marginRight: '5px',
  },

  filename: {
    maxWidth: '270px',
    textOverflow: 'hidden',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  linkBtn: {
    marginLeft: '10px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  flex: {
    flex: 1,
    display: 'flex',
  },
});

const SheetJSFT = ["xlsx", "xlsb", "xlsm", "xls", "xml", "csv", "txt", "ods", "fods", "uos", "sylk", "dif", "dbf", "prn", "qpw", "123", "wb*", "wq*", "html", "htm"
].map(function (x) { return "." + x; }).join(",");

class AddNgExcelDialog extends React.Component {
  initialState = {
    file: null,
    fileName: '',
    items: [],
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  handleUploadClick = () => {
    this.fileUpload.click();
  };

  handleUpload = () => {
    this.props.postNgSendings({ 'ng_sendings': this.state.items });
    this.props.toggleDialog();
  }

  handleFile = (event) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: 'array' });
      /* Get first worksheet */
      const wsname = "入力用";
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const header = ["rowIndex", "corporate_number", "name"];
      const data = XLSX.utils.sheet_to_json(ws, { header: header, skipHeader: true });

      this.processData(data, e.target.file, e.target.fileName);
    };

    const files = event.target.files;
    if (files && files[0]) {
      reader.fileName = files[0].name;
      reader.file = files[0];
      reader.readAsArrayBuffer(files[0]);
    }
  };

  processData = (data, file, fileName) => {
    if (validateNgExcel(data) === false) {
      this.props.displayNotification(
        <div>
          アップロードできませんでした。専用のひな形をご利用ください。
          <span className={this.props.classes.linkBtn} onClick={() => { window.open(process.env.REACT_APP_NG_LIST_EXCEL); }}>
            ひな形をダウンロード
          </span>
        </div>
        , "ghost");
      return;
    }

    this.setState({
      fileName: '',
      items: [],
    });

    let total = data.length;
    let items = [];

    /* read data by row */
    for (let i = 2; i < total; i++) {
      /* create address item */
      let item = AddressBookUtil.makeNgItem(data[i]);

      if (Object.keys(data[i]).length > 1) { // if is a valid row
        for (let p in item) {
          if (p === 'corporate_number') {
            item[p] = numHyphen(removalBlank(zenHan(item[p])));
          }
        }
        items.push(item);
      }
    }

    this.setState({
      items: items,
      file: file,
      fileName: fileName,
    })
  };

  renderExcelUpload = () => {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Button onClick={this.handleUploadClick} color="primary" className={classes.uploadBtn}>
          <Upload width={20} height={20} color="#FFFFFF" style={{ marginRight: '5px' }} />
          <Typography variant="subheading" style={{ color: "#FFFFFF" }}> Excelファイルをアップロード </Typography>
          <input
            type="file"
            accept={SheetJSFT}
            className={classes.hidden}
            ref={(fileUpload) => { this.fileUpload = fileUpload; }}
            onChange={this.handleFile}
          />
        </Button>
      </div>
    )
  }

  renderImportSetting = () => {
    const { classes } = this.props;

    return (
      <div className={classes.importContainer}>
        <div className={classes.row}>
          <Typography variant="subheading" className={classNames(classes.title, classes.flex)}>選択したファイル</Typography>
          <Typography variant="body2" className={classes.filename}>{this.state.fileName}</Typography>
          <Typography
            onClick={this.handleUploadClick}
            variant="body1"
            className={classes.linkBtn}>
            変更
          </Typography>
          <input
            type="file"
            accept={SheetJSFT}
            className={classes.hidden}
            ref={(fileUpload) => { this.fileUpload = fileUpload; }}
            onChange={this.handleFile}
          />
        </div>

        <div className={classes.row}>
          <Typography variant="subheading" className={classNames(classes.title, classes.flex)}>インポート件数</Typography>
          <Typography variant="body2" className={classes.filename}>{this.state.items.length}件</Typography>
        </div>

        <Button
          onClick={this.handleUpload}
          color="primary"
          className={classNames(classes.uploadBtn, this.state.items.length === 0 ? classes.disabledUploadBtn : '')}
          style={{ margin: "40px 0px 30px 0px" }}
          disabled={this.state.items.length === 0}
        >
          インポートを開始
        </Button>
      </div>
    )
  }

  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        classes={{
          contentContainer: classes.contentContainer,
          paper: classes.paper,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={this.props.toggleDialog}
        title={this.state.file ? "インポート設定" : "Excelからインポート"}
      >
        {this.state.file ? this.renderImportSetting() : this.renderExcelUpload()}
      </DialogModal>
    );
  }
}

AddNgExcelDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  postNgSendings: PropTypes.func.isRequired,
  displayNotification: PropTypes.func.isRequired,
};

export default withStyles(styles)(AddNgExcelDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/AddNgExcelDialog.jsx